export default __webpack_public_path__ + "static/media/project-adminpanel.c4970def.png";